(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    // ----- Helper: toggle a single FAQ item -----
    function toggleItem(item) {
      var isOpen = item.classList.contains('open');
      var btn = item.querySelector('.premium-faq__question-btn');
      var answer = item.querySelector('.premium-faq__answer');
      var content = answer ? answer.querySelector('.premium-faq__answer-content') : null;

      if (!btn || !answer || !content) return;

      if (isOpen) {
        // Close
        item.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = '0';
      } else {
        // Close all other open items in the same list
        var list = item.closest('.premium-faq__list');
        if (list) {
          var openItems = list.querySelectorAll('.premium-faq__item.open');
          openItems.forEach(function(other) {
            if (other !== item) {
              var otherBtn = other.querySelector('.premium-faq__question-btn');
              var otherAnswer = other.querySelector('.premium-faq__answer');
              other.classList.remove('open');
              if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
              if (otherAnswer) otherAnswer.style.maxHeight = '0';
            }
          });
        }

        // Open this one
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        // Set max-height to scrollHeight + a tiny buffer
        var height = content.scrollHeight + 1;
        answer.style.maxHeight = height + 'px';
      }
    }

    // ----- Initialise a single FAQ container -----
    function initFAQ(container) {
      // Prevent duplicate initialisation
      if (container.dataset.faqInitialized === 'true') return;
      container.dataset.faqInitialized = 'true';

      var items = container.querySelectorAll('.premium-faq__item');
      if (!items.length) return;

      // Bind click events to each question button
      items.forEach(function(item) {
        var btn = item.querySelector('.premium-faq__question-btn');
        if (btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            toggleItem(item);
          });
        }
      });

      // Handle resize: recalculate max-height for open items
      var resizeTimer;
      function handleResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          var openItems = container.querySelectorAll('.premium-faq__item.open');
          openItems.forEach(function(openItem) {
            var answer = openItem.querySelector('.premium-faq__answer');
            var content = answer ? answer.querySelector('.premium-faq__answer-content') : null;
            if (answer && content) {
              answer.style.maxHeight = content.scrollHeight + 1 + 'px';
            }
          });
        }, 200);
      }

      // Only attach resize listener once per container
      if (!container._resizeListener) {
        window.addEventListener('resize', handleResize);
        container._resizeListener = handleResize;
      }
    }

    // ----- Initialise all FAQ sections on the page -----
    function initAllFAQs() {
      var containers = document.querySelectorAll('[data-section-type="faq"]');
      containers.forEach(function(container) {
        initFAQ(container);
      });
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllFAQs);
    } else {
      initAllFAQs();
    }

    // ----- Re‑initialise on Shopify Theme Editor section reload -----
    document.addEventListener('shopify:section:load', function(event) {
      var target = event.target;
      if (!target) return;

      // The reloaded section might be the outer wrapper or an inner element.
      // Find the actual FAQ container inside.
      var container = target.closest && target.closest('[data-section-type="faq"]');
      if (!container) {
        // If the target itself has the attribute, use it
        if (target.hasAttribute && target.hasAttribute('data-section-type') && target.getAttribute('data-section-type') === 'faq') {
          container = target;
        } else {
          // Search within target
          container = target.querySelector && target.querySelector('[data-section-type="faq"]');
        }
      }

      if (container) {
        // Reset the initialized flag so we can re-bind events
        container.dataset.faqInitialized = 'false';
        // Also remove the resize listener reference to avoid duplicates
        if (container._resizeListener) {
          window.removeEventListener('resize', container._resizeListener);
          container._resizeListener = null;
        }
        // Re-initialize
        initFAQ(container);
      }
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-statistics"] && !Shopify.designMode) return;
  try {
    

(function() {

  'use strict';

  /* ================================
     PARSE NUMBER
  ================================= */

  function parseTarget(str) {

    if (!str) {
      return {
        numeric: 0,
        suffix: ''
      };
    }

    str = str.trim();

    var match = str.match(/^([\d.]+)([KkMmB%]?)(\+?)$/);

    if (!match) {

      var plain = parseFloat(str);

      if (!isNaN(plain)) {
        return {
          numeric: plain,
          suffix: ''
        };
      }

      return {
        numeric: 0,
        suffix: str
      };
    }

    var num = parseFloat(match[1]) || 0;

    var suffix =
      (match[2] || '') +
      (match[3] || '');

    var multiplier = 1;

    if (suffix.toLowerCase().includes('k')) {
      multiplier = 1000;
    }
    else if (suffix.toLowerCase().includes('m')) {
      multiplier = 1000000;
    }
    else if (suffix.toLowerCase().includes('b')) {
      multiplier = 1000000000;
    }

    num = num * multiplier;

    return {
      numeric: num,
      suffix: suffix
    };

  }


  /* ================================
     NUMBER ANIMATION
  ================================= */

  function animateNumber(targetObj, duration) {

    var startTime = performance.now();

    var startVal = 0;

    var endVal = targetObj.targetValue;

    var el = targetObj.el;

    var suffix = targetObj.suffix;

    var raw = targetObj.raw;


    function update(currentTime) {

      var elapsed =
        currentTime - startTime;

      var progress =
        Math.min(elapsed / duration, 1);

      var eased =
        1 - Math.pow(1 - progress, 3);

      var currentVal =
        Math.round(
          startVal +
          (endVal - startVal) * eased
        );


      var display = '';


      if (suffix && suffix.length > 0) {

        var lower =
          suffix.toLowerCase();


        if (lower.includes('k')) {

          if (endVal >= 1000) {

            var kVal =
              (currentVal / 1000)
                .toFixed(1);

            display =
              kVal + 'K';

          } else {

            display =
              currentVal + 'K';

          }

        }

        else if (lower.includes('m')) {

          if (endVal >= 1000000) {

            var mVal =
              (currentVal / 1000000)
                .toFixed(1);

            display =
              mVal + 'M';

          } else {

            display =
              currentVal + 'M';

          }

        }

        else if (lower.includes('b')) {

          if (endVal >= 1000000000) {

            var bVal =
              (currentVal / 1000000000)
                .toFixed(1);

            display =
              bVal + 'B';

          } else {

            display =
              currentVal + 'B';

          }

        }

        else {

          display =
            currentVal.toString();

        }


        if (
          suffix.includes('+') &&
          !display.includes('+')
        ) {

          display += '+';

        }


        if (
          suffix.includes('%') &&
          !display.includes('%')
        ) {

          display += '%';

        }

      }

      else {

        display =
          currentVal.toString();

        if (raw.includes('+')) {
          display += '+';
        }

      }


      el.textContent = display;


      if (progress < 1) {

        requestAnimationFrame(update);

      } else {

        el.textContent = raw;

        targetObj.animated = true;

      }

    }


    requestAnimationFrame(update);

  }


  /* ================================
     INITIALIZE STATISTICS
  ================================= */

  var sections =
    document.querySelectorAll(
      '[data-section-type="statistics"]'
    );


  sections.forEach(function(section) {


    /* NUMBER TARGETS */

    var countElements =
      section.querySelectorAll(
        '.count-target'
      );


    var targets = [];


    countElements.forEach(function(el) {

      var raw =
        el.dataset.target || '0';

      var parsed =
        parseTarget(raw);


      targets.push({

        el: el,

        raw: raw,

        targetValue:
          parsed.numeric,

        suffix:
          parsed.suffix,

        animated: false

      });

    });


    /* START ANIMATION */

    function startAnimations() {

      targets.forEach(function(target) {

        if (!target.animated) {

          animateNumber(
            target,
            1800
          );

        }

      });

    }


    /* VISIBILITY CHECK */

    function isVisible(el) {

      var rect =
        el.getBoundingClientRect();

      var windowHeight =
        window.innerHeight ||
        document.documentElement.clientHeight;

      return (
        rect.top < windowHeight * 0.8 &&
        rect.bottom > 0
      );

    }


    /* RUN WHEN VISIBLE */

    if (isVisible(section)) {

      startAnimations();

    }

    else if (
      'IntersectionObserver' in window
    ) {

      var observer =
        new IntersectionObserver(
          function(entries) {

            entries.forEach(
              function(entry) {

                if (
                  entry.isIntersecting
                ) {

                  startAnimations();

                  observer.unobserve(
                    entry.target
                  );

                }

              }
            );

          },
          {
            threshold: 0.3
          }
        );


      observer.observe(section);

    }

    else {

      setTimeout(
        startAnimations,
        1000
      );

    }


    /* ================================
       SHOPIFY THEME EDITOR RELOAD
    ================================= */

    document.addEventListener(
      'shopify:section:load',
      function(event) {

        var targetSection =
          event.target;


        if (
          targetSection &&
          targetSection.dataset.sectionType ===
          'statistics'
        ) {


          var els =
            targetSection.querySelectorAll(
              '.count-target'
            );


          els.forEach(function(el) {

            el.textContent = '0';

          });


          var newTargets = [];


          els.forEach(function(el) {

            var raw =
              el.dataset.target || '0';

            var parsed =
              parseTarget(raw);


            newTargets.push({

              el: el,

              raw: raw,

              targetValue:
                parsed.numeric,

              suffix:
                parsed.suffix,

              animated: false

            });

          });


          newTargets.forEach(
            function(target) {

              animateNumber(
                target,
                1800
              );

            }
          );

        }

      }
    );

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reels"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    // Simple script to ensure videos autoplay after section load (Shopify dynamic rendering)
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target;
      if (section && section.classList.contains('product-reels-section')) {
        const videos = section.querySelectorAll('.product-reels__video');
        videos.forEach(function(video) {
          if (video.tagName === 'VIDEO') {
            video.play().catch(function(e) {});
          }
        });
      }
    });

    // Also attempt on initial load
    document.querySelectorAll('.product-reels-section .product-reels__video').forEach(function(video) {
      if (video.tagName === 'VIDEO') {
        video.play().catch(function(e) {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    /**
     * TestimonialCarousel – manages slide navigation, autoplay, swipe, and read more/less.
     * Each section instance is scoped to its unique ID.
     */
    class TestimonialCarousel {
      constructor(section) {
        this.section = section;
        this.sectionId = section.dataset.sectionId;

        this.track = section.querySelector('.testimonial-track-' + this.sectionId);
        this.slides = section.querySelectorAll('.testimonial-slide-' + this.sectionId);
        this.dots = section.querySelectorAll('.testimonial-dot-' + this.sectionId);
        this.readToggles = section.querySelectorAll('.testimonial-read-toggle-' + this.sectionId);

        this.currentIndex = 0;
        this.totalSlides = this.slides.length;
        this.interval = null;
        this.isPaused = false;

        // Read settings
        const settings = this.section.dataset;
        this.autoplay = settings.enableAutoplay === 'true';
        this.intervalMs = parseInt(settings.autoplayInterval, 10) || 5000;
        this.pauseOnHover = settings.pauseOnHover === 'true';
        this.swipeEnabled = settings.enableSwipe === 'true';

        if (this.totalSlides === 0) return;

        this.init();
      }

      init() {
        // Show initial slide
        this.goTo(0, false);

        // Dot clicks
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const idx = parseInt(dot.dataset.slideIndex, 10);
            if (idx !== this.currentIndex) {
              this.goTo(idx);
            }
          });
        });

        // Read more/less toggles
        this.readToggles.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const slide = btn.closest('.testimonial-slide-' + this.sectionId);
            const textContainer = slide.querySelector('.testimonial-text-' + this.sectionId);
            const isExpanded = textContainer.classList.contains('expanded');
            textContainer.classList.toggle('expanded');
            btn.setAttribute('aria-expanded', !isExpanded);
            // If expanded, pause autoplay
            if (!isExpanded && this.autoplay) {
              this.pauseAutoplay();
            } else if (isExpanded && this.autoplay) {
              this.resumeAutoplay();
            }
          });
        });

        // Hover (pause/resume)
        if (this.pauseOnHover && this.autoplay) {
          this.section.addEventListener('mouseenter', () => this.pauseAutoplay());
          this.section.addEventListener('mouseleave', () => this.resumeAutoplay());
        }

        // Swipe
        if (this.swipeEnabled) {
          let startX = 0;
          let isSwiping = false;
          const slidesContainer = this.section.querySelector('.testimonial-slides-' + this.sectionId);
          slidesContainer.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
            isSwiping = true;
            if (this.autoplay) this.pauseAutoplay();
          }, { passive: true });
          slidesContainer.addEventListener('touchmove', (e) => {
            // prevent page scroll while swiping? optional
          }, { passive: true });
          slidesContainer.addEventListener('touchend', (e) => {
            if (!isSwiping) return;
            const endX = e.changedTouches[0].clientX;
            const diff = startX - endX;
            const threshold = 40;
            if (Math.abs(diff) > threshold) {
              if (diff > 0) {
                // swipe left -> next
                this.next();
              } else {
                // swipe right -> previous
                this.prev();
              }
            }
            isSwiping = false;
            if (this.autoplay) this.resumeAutoplay();
          }, { passive: true });
        }

        // Autoplay start
        if (this.autoplay) {
          this.startAutoplay();
        }

        // Handle section re-render in Theme Editor
        document.addEventListener('shopify:section:load', (event) => {
          if (event.target === this.section) {
            this.destroy();
            this.reinit();
          }
        });
      }

      goTo(index, animate = true) {
        if (index < 0) index = this.totalSlides - 1;
        if (index >= this.totalSlides) index = 0;
        this.currentIndex = index;
        const offset = -index * 100;
        this.track.style.transition = animate ? 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
        this.track.style.transform = 'translateX(' + offset + '%)';
        // Update dots
        this.dots.forEach((dot, i) => {
          const isActive = i === index;
          dot.classList.toggle('active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      next() {
        this.goTo(this.currentIndex + 1);
      }

      prev() {
        this.goTo(this.currentIndex - 1);
      }

      startAutoplay() {
        if (this.interval) clearInterval(this.interval);
        this.interval = setInterval(() => {
          if (!this.isPaused) {
            // Check if any slide is expanded; if so, skip auto-slide
            let expanded = false;
            this.slides.forEach((slide) => {
              const text = slide.querySelector('.testimonial-text-' + this.sectionId);
              if (text && text.classList.contains('expanded')) {
                expanded = true;
              }
            });
            if (!expanded) {
              this.next();
            }
          }
        }, this.intervalMs);
      }

      pauseAutoplay() {
        if (this.autoplay) {
          this.isPaused = true;
        }
      }

      resumeAutoplay() {
        if (this.autoplay) {
          this.isPaused = false;
        }
      }

      destroy() {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
      }

      reinit() {
        // Re-read settings and restart
        const settings = this.section.dataset;
        this.autoplay = settings.enableAutoplay === 'true';
        this.intervalMs = parseInt(settings.autoplayInterval, 10) || 5000;
        this.pauseOnHover = settings.pauseOnHover === 'true';
        this.swipeEnabled = settings.enableSwipe === 'true';
        if (this.interval) clearInterval(this.interval);
        if (this.autoplay) this.startAutoplay();
        // Ensure slide position is correct
        this.goTo(this.currentIndex, false);
      }
    }

    // Initialize all sections on the page
    const instances = {};

    function initSection(section) {
      const id = section.dataset.sectionId;
      if (!id) return;
      if (instances[id]) {
        instances[id].destroy();
        delete instances[id];
      }
      instances[id] = new TestimonialCarousel(section);
    }

    document.querySelectorAll('.testimonial-carousel').forEach((section) => {
      if (section.dataset.sectionId) initSection(section);
    });

    // Shopify Theme Editor: when a section is loaded dynamically
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (section && section.classList && section.classList.contains('testimonial-carousel')) {
        if (!section.dataset.sectionId) {
          const id = section.getAttribute('data-section-id') || section.id;
          if (id) section.dataset.sectionId = id;
        }
        if (section.dataset.sectionId) initSection(section);
      }
    });

    // Reinitialize on reorder (blocks changed)
    document.addEventListener('shopify:section:reorder', () => {
      document.querySelectorAll('.testimonial-carousel').forEach((section) => {
        if (section.dataset.sectionId) initSection(section);
      });
    });

    // Fallback: ensure all sections are initialized after a short delay
    setTimeout(() => {
      document.querySelectorAll('.testimonial-carousel').forEach((section) => {
        if (section.dataset.sectionId && !instances[section.dataset.sectionId]) {
          initSection(section);
        }
      });
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /**
     * VideoReelsCarousel
     * Lightweight vanilla JS carousel for the Video Reels section
     * Supports desktop (3 slides visible) and mobile (1 slide visible)
     * Now with autoplay every 6 seconds (configurable)
     */
    class VideoReelsCarousel {
      /**
       * @param {HTMLElement} section - The section root element
       */
      constructor(section) {
        this.section = section;
        this.track = section.querySelector('.video-reels-track');
        this.inner = section.querySelector('.video-reels-carousel-inner');
        this.slides = section.querySelectorAll('.video-reels-slide');
        this.prevBtn = section.querySelector('.video-reels-arrow-prev');
        this.nextBtn = section.querySelector('.video-reels-arrow-next');
        this.dots = section.querySelectorAll('.video-reels-dot');

        // Read autoplay settings from data attributes
        const sectionData = this.section.dataset;
        this.enableCarouselAutoplay = sectionData.carouselAutoplay === 'true';
        this.carouselInterval = parseInt(sectionData.carouselInterval, 10) || 6000;

        this.currentIndex = 0;
        this.slidesPerView = 3;
        this.totalSlides = this.slides.length;
        this.maxIndex = Math.max(0, this.totalSlides - this.slidesPerView);
        this.isMobile = window.innerWidth < 750;
        this.isTablet = window.innerWidth >= 750 && window.innerWidth < 990;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.isDragging = false;
        this.hasBeenInitialized = false;
        this.autoplayTimer = null;
        this.isHovering = false;

        if (this.totalSlides === 0) return;

        this.init();
      }

      init() {
        this.setSlidesPerView();
        this.setMaxIndex();
        this.updateCarousel();
        this.bindEvents();
        this.handleVideos();
        this.startAutoplay();
        this.hasBeenInitialized = true;
      }

      setSlidesPerView() {
        const width = window.innerWidth;
        if (width < 750) {
          this.slidesPerView = 1;
          this.isMobile = true;
          this.isTablet = false;
        } else if (width >= 750 && width < 990) {
          this.slidesPerView = 2;
          this.isMobile = false;
          this.isTablet = true;
        } else {
          this.slidesPerView = 3;
          this.isMobile = false;
          this.isTablet = false;
        }
        this.maxIndex = Math.max(0, this.totalSlides - this.slidesPerView);
        if (this.currentIndex > this.maxIndex) {
          this.currentIndex = this.maxIndex;
        }
        if (this.currentIndex < 0) {
          this.currentIndex = 0;
        }
        // Update slide flex basis
        this.slides.forEach((slide) => {
          slide.style.flex = `0 0 calc(100% / ${this.slidesPerView})`;
        });
      }

      setMaxIndex() {
        this.maxIndex = Math.max(0, this.totalSlides - this.slidesPerView);
        if (this.currentIndex > this.maxIndex) {
          this.currentIndex = this.maxIndex;
        }
      }

      updateCarousel() {
        const percent = 100 / this.slidesPerView;
        const translate = -this.currentIndex * percent;
        if (this.isMobile) {
          // On mobile we use scroll-snap, no transform needed
          // But we need to scroll to the correct slide
          this.scrollToSlide(this.currentIndex);
        } else {
          this.track.style.transform = `translateX(${translate}%)`;
        }
        this.updateButtons();
        this.updateDots();
        this.updateSlideVisibility();
        // Reset autoplay timer on manual move (restart)
        this.resetAutoplay();
      }

      scrollToSlide(index) {
        const slide = this.slides[index];
        if (slide) {
          slide.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });
        }
      }

      updateButtons() {
        if (!this.prevBtn || !this.nextBtn) return;
        this.prevBtn.disabled = this.currentIndex <= 0;
        this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
        // Hide arrows if not enough slides
        if (this.totalSlides <= this.slidesPerView) {
          this.prevBtn.style.display = 'none';
          this.nextBtn.style.display = 'none';
        } else {
          this.prevBtn.style.display = 'flex';
          this.nextBtn.style.display = 'flex';
        }
      }

      updateDots() {
        if (this.dots.length === 0) return;
        const activeIndex = Math.min(this.currentIndex, this.dots.length - 1);
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('video-reels-dot-active', i === activeIndex);
        });
      }

      updateSlideVisibility() {
        // For desktop/tablet, we could add opacity transitions for edge slides
        // but keeping it simple for performance
      }

      goTo(index) {
        const target = Math.max(0, Math.min(index, this.maxIndex));
        if (target === this.currentIndex) return;
        this.currentIndex = target;
        this.updateCarousel();
        // If mobile, ensure the scroll happens
        if (this.isMobile) {
          this.scrollToSlide(this.currentIndex);
        }
        // Reset autoplay timer after manual navigation
        this.resetAutoplay();
      }

      goPrev() {
        if (this.currentIndex > 0) {
          this.goTo(this.currentIndex - 1);
        }
      }

      goNext() {
        if (this.currentIndex < this.maxIndex) {
          this.goTo(this.currentIndex + 1);
        }
      }

      bindEvents() {
        // Prev / Next buttons
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.goPrev();
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.goNext();
          });
        }

        // Dots
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const index = parseInt(dot.dataset.index, 10);
            if (!isNaN(index) && index <= this.maxIndex) {
              this.goTo(index);
            }
          });
        });

        // Touch events for mobile swipe
        if (this.isMobile && this.inner) {
          this.inner.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
          this.inner.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: true });
          this.inner.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
        }

        // Keyboard navigation
        this.section.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.goPrev();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.goNext();
          }
        });

        // Pause on hover (desktop only)
        const carouselEl = this.section.querySelector('.video-reels-carousel');
        if (carouselEl) {
          carouselEl.addEventListener('mouseenter', () => {
            this.isHovering = true;
            this.stopAutoplay();
          });
          carouselEl.addEventListener('mouseleave', () => {
            this.isHovering = false;
            this.startAutoplay();
          });
        }

        // Resize
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            const wasMobile = this.isMobile;
            const width = window.innerWidth;
            const newIsMobile = width < 750;
            const newIsTablet = width >= 750 && width < 990;
            if (wasMobile !== newIsMobile || this.isTablet !== newIsTablet) {
              this.isMobile = newIsMobile;
              this.isTablet = newIsTablet;
              this.setSlidesPerView();
              this.setMaxIndex();
              this.updateCarousel();
            }
          }, 200);
        });

        // Shopify's Theme Editor: re-initialize on section change
        document.addEventListener('shopify:section:load', (e) => {
          if (e.target === this.section || e.target.closest && e.target.closest('.video-reels-section') === this.section) {
            // Re-initialize
            setTimeout(() => {
              this.setSlidesPerView();
              this.setMaxIndex();
              this.updateCarousel();
              this.handleVideos();
              this.startAutoplay();
            }, 100);
          }
        });

        // Shopify's Theme Editor: block changes
        document.addEventListener('shopify:block:select', (e) => {
          // Just ensure carousel is in correct state
        });
        document.addEventListener('shopify:block:deselect', () => {
          // No-op
        });
      }

      onTouchStart(e) {
        this.touchStartX = e.touches[0].clientX;
        this.isDragging = true;
        // Pause autoplay on touch start
        this.stopAutoplay();
      }

      onTouchMove(e) {
        if (!this.isDragging) return;
        this.touchEndX = e.touches[0].clientX;
      }

      onTouchEnd() {
        if (!this.isDragging) return;
        this.isDragging = false;
        const diff = this.touchStartX - this.touchEndX;
        const threshold = 50;
        if (Math.abs(diff) > threshold) {
          if (diff > 0) {
            this.goNext();
          } else {
            this.goPrev();
          }
        }
        this.touchStartX = 0;
        this.touchEndX = 0;
        // Restart autoplay after touch ends (unless hovering)
        if (!this.isHovering) {
          this.startAutoplay();
        }
      }

      handleVideos() {
        // For each video, ensure it loads correctly
        const videos = this.section.querySelectorAll('.video-reels-video');
        videos.forEach((video) => {
          // Ensure muted attribute is set for autoplay
          video.muted = true;
          // If autoplay is enabled, try to play
          const sectionData = this.section.dataset;
          if (sectionData.autoplay === 'true') {
            video.play().catch(() => {
              // Autoplay was blocked, user will need to interact
              // We could add a subtle click-to-play indicator here
            });
          }
          // Handle click to toggle play/pause if not a link
          const slide = video.closest('.video-reels-slide');
          if (slide && slide.dataset.hasLink === 'false') {
            const wrapper = video.closest('.video-reels-video-wrapper');
            if (wrapper) {
              wrapper.addEventListener('click', (e) => {
                if (e.target.closest('.video-reels-overlay')) return;
                if (video.paused) {
                  video.play().catch(() => {});
                } else {
                  video.pause();
                }
              });
            }
          }
        });
      }

      // ===== AUTOPLAY METHODS =====
      startAutoplay() {
        // Only start if enabled, carousel has more slides than visible, and not already running
        if (!this.enableCarouselAutoplay) return;
        if (this.totalSlides <= this.slidesPerView) return;
        if (this.autoplayTimer) return;
        if (this.isHovering) return;
        if (this.isMobile) {
          // On mobile, we use scroll-snap but we can still advance via JS
          // We'll just use the same timer
        }
        this.autoplayTimer = setInterval(() => {
          this.goNext();
        }, this.carouselInterval);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      resetAutoplay() {
        // Restart the timer (stop and start)
        this.stopAutoplay();
        this.startAutoplay();
      }

      /**
       * Public method to reinitialize the carousel
       * Useful for Theme Editor dynamic updates
       */
      reinit() {
        this.totalSlides = this.slides.length;
        this.setSlidesPerView();
        this.setMaxIndex();
        this.updateCarousel();
        this.handleVideos();
        this.stopAutoplay();
        this.startAutoplay();
      }

      /**
       * Clean up event listeners (if needed)
       */
      destroy() {
        this.stopAutoplay();
        // Remove listeners if we were storing them with .bind
        // For this implementation, we use passive listeners and inline
        // so cleanup is minimal
      }
    }

    // ============================================================
    //  INITIALIZE — Find all .video-reels-section instances
    // ============================================================

    const sections = document.querySelectorAll('.video-reels-section');

    // Store carousel instances for potential future use
    const carousels = [];

    sections.forEach((section) => {
      // Skip if already initialized (data attribute)
      if (section.dataset.carouselInitialized === 'true') return;

      try {
        const carousel = new VideoReelsCarousel(section);
        carousels.push(carousel);
        section.dataset.carouselInitialized = 'true';
      } catch (err) {
        // Silent fail — carousel degrades gracefully
        console.warn('VideoReels: Could not initialize carousel', err);
      }
    });

    // Shopify Theme Editor: re-run when sections are reloaded dynamically
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (section && section.classList && section.classList.contains('video-reels-section')) {
        // Check if already initialized
        if (section.dataset.carouselInitialized === 'true') {
          // Reinitialize existing carousel
          const existing = carousels.find((c) => c.section === section);
          if (existing) {
            setTimeout(() => {
              existing.reinit();
            }, 100);
          }
        } else {
          // Create new carousel
          try {
            const carousel = new VideoReelsCarousel(section);
            carousels.push(carousel);
            section.dataset.carouselInitialized = 'true';
          } catch (err) {
            // Silent fail
          }
        }
      }
    });

    // Also handle Shopify's dynamic section rendering for Theme Editor
    document.addEventListener('shopify:section:reorder', () => {
      // Reinitialize any sections that might have been affected
      setTimeout(() => {
        document.querySelectorAll('.video-reels-section').forEach((section) => {
          if (section.dataset.carouselInitialized === 'true') {
            const existing = carousels.find((c) => c.section === section);
            if (existing) {
              existing.reinit();
            }
          }
        });
      }, 200);
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wave-ticker"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    /**
     * WaveTicker - drives the horizontal infinite scroll using requestAnimationFrame.
     * Each section instance manages its own animation loop.
     */
    class WaveTicker {
      constructor(section) {
        this.section = section;
        this.sectionId = section.dataset.sectionId;
        this.track = section.querySelector('.wave-ticker-track-' + this.sectionId);
        this.group1 = section.querySelector('.wave-ticker-group-' + this.sectionId + '[data-group="1"]');
        this.group2 = section.querySelector('.wave-ticker-group-' + this.sectionId + '[data-group="2"]');
        this.viewport = section.querySelector('.wave-ticker-viewport-' + this.sectionId);

        // State
        this.position = 0;
        this.groupWidth = 0;
        this.animationId = null;
        this.isPaused = false;
        this.isRunning = false;

        // Bind methods
        this.animate = this.animate.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleHover = this.handleHover.bind(this);
        this.handleLeave = this.handleLeave.bind(this);

        this.measureAndStart();

        // Event listeners
        this.pauseOnHover = this.section.dataset.pauseOnHover === 'true';
        if (this.pauseOnHover) {
          this.section.addEventListener('mouseenter', this.handleHover);
          this.section.addEventListener('mouseleave', this.handleLeave);
        }

        window.addEventListener('resize', this.handleResize);

        // Shopify section load/re-render events
        document.addEventListener('shopify:section:load', (event) => {
          if (event.target === this.section) {
            this.destroy();
            this.measureAndStart();
          }
        });

        const observer = new MutationObserver(() => {
          this.destroy();
          this.measureAndStart();
        });
        observer.observe(this.section, { childList: true, subtree: true });
        this.observer = observer;
      }

      measureAndStart() {
        if (!this.group1 || !this.group2) return;

        // Reset transforms to measure correctly
        this.group1.style.transform = 'none';
        this.group2.style.transform = 'none';
        this.track.style.transform = 'translate3d(0, 0, 0)';

        // Measure the distance between the left edges of group1 and group2.
        const rect1 = this.group1.getBoundingClientRect();
        const rect2 = this.group2.getBoundingClientRect();
        const distance = rect2.left - rect1.left;

        if (distance > 0) {
          this.groupWidth = distance;
        } else {
          this.groupWidth = this.group1.offsetWidth;
        }

        if (this.groupWidth === 0) return;

        // Read speed from CSS variable (seconds per full cycle)
        const style = getComputedStyle(this.section);
        const speedSeconds = parseFloat(style.getPropertyValue('--ticker-speed')) || 30;
        this.speed = this.groupWidth / (speedSeconds * 1000);

        this.position = 0;
        this.track.style.transform = 'translate3d(0, 0, 0)';

        if (!this.isRunning) {
          this.isRunning = true;
          this.lastTimestamp = performance.now();
          this.animationId = requestAnimationFrame(this.animate);
        }
      }

      animate(timestamp) {
        if (!this.isRunning) return;

        if (!this.isPaused) {
          const delta = timestamp - this.lastTimestamp;
          if (delta > 0) {
            this.position -= this.speed * delta;
            if (Math.abs(this.position) >= this.groupWidth) {
              this.position += this.groupWidth;
            }
            this.track.style.transform = 'translate3d(' + this.position + 'px, 0, 0)';
          }
        }

        this.lastTimestamp = timestamp;
        this.animationId = requestAnimationFrame(this.animate);
      }

      handleHover() {
        if (this.pauseOnHover) this.isPaused = true;
      }

      handleLeave() {
        if (this.pauseOnHover) {
          this.isPaused = false;
          this.lastTimestamp = performance.now();
        }
      }

      handleResize() {
        this.destroy();
        this.measureAndStart();
      }

      destroy() {
        if (this.animationId) {
          cancelAnimationFrame(this.animationId);
          this.animationId = null;
        }
        this.isRunning = false;
        if (this.observer) this.observer.disconnect();
        if (this.pauseOnHover) {
          this.section.removeEventListener('mouseenter', this.handleHover);
          this.section.removeEventListener('mouseleave', this.handleLeave);
        }
        window.removeEventListener('resize', this.handleResize);
      }
    }

    // Initialize all sections
    const instances = {};

    function initSection(section) {
      const id = section.dataset.sectionId;
      if (!id) return;
      if (instances[id]) {
        instances[id].destroy();
        delete instances[id];
      }
      const group1 = section.querySelector('.wave-ticker-group-' + id + '[data-group="1"]');
      if (group1 && group1.children.length > 0) {
        instances[id] = new WaveTicker(section);
      }
    }

    document.querySelectorAll('.wave-ticker-section').forEach(section => {
      if (section.dataset.sectionId) initSection(section);
    });

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (section && section.classList && section.classList.contains('wave-ticker-section')) {
        if (!section.dataset.sectionId) {
          const id = section.getAttribute('data-section-id') || section.id;
          if (id) section.dataset.sectionId = id;
        }
        if (section.dataset.sectionId) initSection(section);
      }
    });

    document.addEventListener('shopify:section:reorder', () => {
      document.querySelectorAll('.wave-ticker-section').forEach(section => {
        if (section.dataset.sectionId) initSection(section);
      });
    });

    setTimeout(() => {
      document.querySelectorAll('.wave-ticker-section').forEach(section => {
        if (section.dataset.sectionId) initSection(section);
      });
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();
})();
